import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AppService } from 'src/app/_services/app.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { DialogStatusComponent } from 'src/app/dialog/dialog-status/dialog-status.component';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
    selector: 'app-event-logs',
    templateUrl: './event-logs.component.html',
    styleUrls: ['./event-logs.component.css'],
    animations: [
        trigger('slider', [
            state('*', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class EventLogsComponent implements AfterViewInit {

  displayColumns: string[] = ['status', 'username', 'organisation', 'category', 'event', 'details', 'ipaddress', 'date'];
  mattablePageSize = 30;
  mattableLength = 0;
  loading: boolean;
  allEventLogs: LogDetail[];

  // isSelectedAdvancedFilters = false;
  // typeFilter: string = 'all';
  // allHeaderFilter: boolean = true;
  // eventHeaderFilter: boolean = false;
  // detailsHeaderFilter: boolean = false;
  // ipHeaderFilter: boolean = false;

  logList: LogDetail[] = null;

  usernameFilter: string;
  usernameFilterType: string = 'temp';
  usernameFilterEnabled: boolean = false;

  organisationFilter: string;
  organisationFilterType: string = 'temp';
  organisationFilterEnabled: boolean = false;

  eventFilter: string;
  eventFilterType: string = 'temp';
  eventFilterEnabled: boolean = false;

  categoryFilter: string;
  categoryFilterType: string = 'temp';
  categoryFilterEnabled: boolean = false;

  detailsFilter: string;
  detailsFilterType: string = 'temp';
  detailsFilterEnabled: boolean = false;

  ipFilter: string;
  ipFilterType: string = 'temp';
  ipFilterEnabled: boolean = false;

  startDateFilter: Date = null;
  startDateFilterEnabled: boolean = false;

  endDateFilter: Date = null;
  endDateFilterEnabled: boolean = false;

  statusFilter: string = 'temp';
  statusFilterEnabled: boolean = false;


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private service: AppService, private dialog: MatDialog, private translate: TranslateService) {
    this.service.SetTranslation('administration/event-logs');
  }

  ngAfterViewInit() {

     this.GetLogs([]);

    // // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.ApplyFilterOptions(false);
    });

    this.paginator.page.subscribe(() => {
      this.ApplyFilterOptions(false);
    });
  }

  /** Listing to the page resizizing event */
  OnPagesizeChange() {
    this.paginator.pageSize = this.mattablePageSize;
    this.paginator.pageIndex = 0;
    this.ApplyFilterOptions(false);
  }


  /** Gets all the events from server */
  GetLogs(filterOptions: Filter[]) {
    if (this.logList !== null) {
      this.logList = [];
    }
    this.loading = true;
    this.http.post<LogsData>(this.baseUrl + 'api/reports/getEventLogs/' + this.sort.active + '/' + this.sort.direction + '/' + this.paginator.pageIndex + '/' + this.paginator.pageSize, filterOptions).subscribe(result => {
      this.mattableLength = result.totalCount;
      // this.allEventLogs = result;
      this.logList = result.logs;
      this.loading = false;
    }, error => {
      console.error(error);
    });
  }

  /**
   *  Resetting the date filter
   * @param date Start or Finish date
   */
  ResetDateFilter(date: string) {
    if (date === 'start') {
      this.startDateFilter = null;
      this.ApplyFilterOptions(false);
    } else if (date === 'end') {
      this.endDateFilter = null;
      this.ApplyFilterOptions(false);
    }
  }

  /**
   * Applying the filters
   * @param opened boolean that represents the pop-up open status for filter type
   */
  ApplyFilterOptions(opened: boolean) {
    if (!opened) {
      const filterOptions = this.GenerateFilterOptions();
      this.GetLogs(filterOptions);
    }
  }

  /** Generates the filter options */
  GenerateFilterOptions(): Filter[] {
    const filterOptions: Filter[] = [];
      this.usernameFilterEnabled = false;
      this.organisationFilterEnabled = false;
      this.statusFilterEnabled = false;
      this.eventFilterEnabled = false;
      this.categoryFilterEnabled = false;
      this.detailsFilterEnabled = false;
      this.ipFilterEnabled = false;
      this.startDateFilterEnabled = false;
      this.endDateFilterEnabled = false;

      if (this.statusFilter !== 'temp') {
        this.statusFilterEnabled = true;
        filterOptions.push({
          header: 'Status',
          type: '',
          value: this.statusFilter
        });
      }

      if (this.usernameFilter && this.usernameFilterType !== 'temp' && this.usernameFilterType !== 'noFilter') {
        this.usernameFilterEnabled = true;
        filterOptions.push({
          header: 'Username',
          type: this.usernameFilterType,
          value: this.usernameFilter
        });
      }

      if (this.organisationFilter && this.organisationFilterType !== 'temp' && this.organisationFilterType !== 'noFilter') {
        this.organisationFilterEnabled = true;
        filterOptions.push({
          header: 'Organisation',
          type: this.organisationFilterType,
          value: this.organisationFilter
        });
      }

      if (this.eventFilter && this.eventFilterType !== 'temp' && this.eventFilterType !== 'noFilter') {
        this.eventFilterEnabled = true;
        filterOptions.push({
          header: 'Event',
          type: this.eventFilterType,
          value: this.eventFilter
        });
      }

      if (this.categoryFilter && this.categoryFilterType !== 'temp' && this.categoryFilterType !== 'noFilter') {
        this.categoryFilterEnabled = true;
        filterOptions.push({
          header: 'Category',
          type: this.categoryFilterType,
          value: this.categoryFilter
        });
      }

      if (this.detailsFilter && this.detailsFilterType !== 'temp' && this.detailsFilterType !== 'noFilter') {
        this.detailsFilterEnabled = true;
        filterOptions.push({
          header: 'Details',
          type: this.detailsFilterType,
          value: this.detailsFilter
        });
      }

      if (this.ipFilter && this.ipFilterType !== 'temp' && this.ipFilterType !== 'noFilter') {
        this.ipFilterEnabled = true;
        filterOptions.push({
          header: 'IP Address',
          type: this.ipFilterType,
          value: this.ipFilter
        });
      }

      if (this.startDateFilter !== null || this.endDateFilter !== null) {
        if (this.startDateFilter !== null) {
          const momentUtc = moment(this.startDateFilter);
          this.startDateFilterEnabled = true;
          filterOptions.push({
            header: 'StartDate',
            type: '',
            value: new Date(Date.UTC(momentUtc.year(), momentUtc.month(), momentUtc.date())).toISOString()
          });
        }

        if (this.endDateFilter !== null) {
          const momentUtc = moment(this.endDateFilter);
          this.endDateFilterEnabled = true;
          filterOptions.push({
            header: 'EndDate',
            type: '',
            value: new Date(Date.UTC(momentUtc.year(), momentUtc.month(), momentUtc.date())).toISOString()
          });
        }
      }

      return filterOptions;
  }

  /** Click function for username to display details */
  OnClickUsername(user: LogUser) {
    if (user.firstName !== '') {
      const message = '<div class="row">' +
      '<div class="col-6">' +
      '  <div class="col-12">' +
      '    <mat-label><b>' + this.translate.instant('Reports.Logs.thUsername') + '</b></mat-label>' +
      '  </div>' +
      '  <div class="col-12">' +
      '    <mat-label><b>' + this.translate.instant('Reports.Logs.lblFName') + '</b></mat-label>' +
      '  </div>' +
      '  <div class="col-12">' +
      '    <mat-label><b>' + this.translate.instant('Reports.Logs.lblLName') + '</b></mat-label>' +
      '  </div>' +
      '  <div class="col-12">' +
      '    <mat-label><b>' + this.translate.instant('Reports.Logs.lblOrg') + '</b></mat-label>' +
      '  </div>' +
      '</div>' +
      '<div class="col-6">' +
      '  <div class="col-12">' +
      '    ' + user.username + '' +
      '  </div>' +
      '  <div class="col-12">' +
      '    ' + user.firstName + '' +
      '  </div>' +
      '  <div class="col-12">' +
      '    ' + user.lastName + '' +
      '  </div>' +
      '  <div class="col-12">' +
      '    ' + user.organisation + '' +
      '  </div>' +
      '</div>';

      this.dialog.open(DialogStatusComponent, {
        disableClose: true,
        data: {
          title: this.translate.instant('Reports.Logs.headerUserDetails'),
          message: message,
          innerHTML: true
        },
        position: { top: '5%' }
      });
    }
  }

  /** Export details to excel */
  OnClickExport() {
    this.service.showSpinner();
    const filterOptions = this.GenerateFilterOptions();
    this.http.post(this.baseUrl + 'api/reports/exportLogs/' + this.sort.active + '/' + this.sort.direction, filterOptions, { responseType: 'text'}).subscribe(result => {
      if (result !== '') {
        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = 'Event Logs Export.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
        document.removeChild(anchor);
      } else {
        this.service.SaveStatus(false, 'Messages.msgHeaderExport', 'Messages.msgErrorTryAgain');
        // this.service.SaveStatus(false, 'Export to Excel', 'Something went wrong. Please try again later or contact administration.');
      }
    }, error => {
      console.error(error);
    }).add(() => {
      this.service.hideSpinner();
    });
  }



  /** applying filter for dataSources */
  // ApplyFilter() {
  //   if (this.isSelectedAdvancedFilters === false) {
  //     this.dataSource.filter = this.searchKey.trim().toLowerCase();
  //   }
  // }

  // OnClickAdvancedFilters() {
  //   this.isSelectedAdvancedFilters = !this.isSelectedAdvancedFilters;
  //   if (this.isSelectedAdvancedFilters === false) {
  //     this.ResetAdvancedFilter();
  //   }
  // }

  // /** applying advanced filter options */
  // ApplyAdvancedFilter() {
  //   this.dataSource.data = this.allEventLogs;
  //   // Checking type filter
  //   if (this.typeFilter !== 'all') {
  //     this.dataSource.data = this.dataSource.data.filter(e => e.icon === this.typeFilter);
  //   }
  //   // Checking header filters
  //   if (this.allHeaderFilter === false && this.searchKey.trim() !== '') {
  //     let events: LogDetail[] = null;
  //     let details: LogDetail[] = null;
  //     let ip: LogDetail[] = null;

  //     if (this.eventHeaderFilter === true) {
  //       // filtering values which contains the search value
  //       events = this.dataSource.data.filter(e => e.event.trim().toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) > -1);
  //     }

  //     if (this.detailsHeaderFilter ===  true) {
  //       details = this.dataSource.data.filter(e => e.details.trim().toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) > -1);
  //     }

  //     if (this.ipHeaderFilter === true) {
  //       ip = this.dataSource.data.filter(e => e.ipaddress.trim().toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) > -1);
  //     }
  //     // Concat all the arrays (following mthod is nullable safe)
  //     const filteredData: LogDetail[] = [...(events || []), ...(details || []), ...(ip || [])];

  //     // removing duplicates
  //     this.dataSource.data = filteredData.filter((value, index) => filteredData.indexOf(value) === index);
  //   }
  //   // Checking data filter
  //   if (this.startDateFilter !== null || this.endDateFilter !== null) {
  //     if (this.startDateFilter !== null && this.endDateFilter !== null) {
  //       this.dataSource.data = this.dataSource.data.filter(e => new Date(e.date) <= this.endDateFilter && new Date(e.date) >= this.startDateFilter);
  //     } else if (this.startDateFilter !== null) {
  //       this.dataSource.data = this.dataSource.data.filter(e => new Date(e.date) >= this.startDateFilter);
  //     } else if (this.endDateFilter !== null) {
  //       this.dataSource.data = this.dataSource.data.filter(e => new Date(e.date) <= this.endDateFilter);
  //     }
  //   }
  //   // Assigning length to display message when there are no logs to display
  //   this.mattableLength = this.dataSource.data.length;
  // }

  // /** Reset all the filters */
  // ResetAdvancedFilter() {
  //   this.endDateFilter = null;
  //   this.startDateFilter = null;
  //   this.typeFilter = 'all';
  //   this.allHeaderFilter = true;
  //   this.eventHeaderFilter = false;
  //   this.detailsHeaderFilter = false;
  //   this.ipHeaderFilter = false;
  //   this.isSelectedAdvancedFilters = false;
  //   this.dataSource.data = this.allEventLogs;
  //   this.OnSearchClear();
  // }
  // /**
  //  * method to handle user inputs on header filters selections (avoid selecting both all and any others)
  //  * @param id selected checkbox id
  //  */
  // OnChangeHeaders(id: number) {
  //   if (this.allHeaderFilter === true && id === 0) {
  //     this.eventHeaderFilter = false;
  //     this.detailsHeaderFilter = false;
  //     this.ipHeaderFilter = false;
  //   } else {
  //     this.allHeaderFilter = false;
  //   }
  // }

  // /** clear and close search user and set to the initial userlist by calling applyfilter */
  // OnSearchClear() {
  //   this.searchKey = '';
  //   this.ApplyFilter();
  // }

}

/** An interface to access filtered data from server */
interface LogsData {
  logs: LogDetail[];
  totalCount: number;
}

/** An interface for access filter details */
interface Filter {
  value: string;
  header: string;
  type: string;
}

/** Interface for map server response */
interface LogDetail {
  icon: string;
  status: string;
  category: string;
  event: string;
  details: string;
  ipaddress: string;
  date: string;
  imperson: string;
  user: LogUser;
}

/** Interface for access user details */
interface LogUser {
  username: string;
  firstName: string;
  lastName: string;
  organisation: string;
}
